module.exports = __webpack_public_path__ + "static/img/15203070371.5eb4e66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15203070371.jpg
// module id = 43PB
// module chunks = 0